import { Scenario } from "../gateway/Scenario/Scenario";

/**
 * Cenários de várias empresas numa única requisição, agrupados por empresa.
 *
 * Nasceu para a automação de envio, onde o agendamento pode ter centenas de empresas: buscar
 * cenário linha a linha seria uma requisição por empresa.
 */
export class GetScenariosByCompaniesUsecase {
    constructor() {
        this.ScenarioGateway = new Scenario();
    }

    async execute({ companyIds = [], source = "" } = {}) {
        const payload = this.sanitizeInput({ companyIds, source });

        if (!payload.companyIds.length) return {};

        try {
            const scenariosByCompanyId = await this.ScenarioGateway.getByCompanyIds(
                payload.companyIds
            );
            if (!payload.source) return scenariosByCompanyId;
            return this.filterBySource(scenariosByCompanyId, payload.source);
        } catch (error) {
            throw new Error(
                error.message || "Não foi possível carregar os cenários"
            );
        }
    }

    filterBySource(scenariosByCompanyId, source) {
        const filtered = {};
        Object.keys(scenariosByCompanyId).forEach((companyId) => {
            const scenarios = scenariosByCompanyId[companyId].filter(
                (scenario) => !scenario.source || scenario.source === source
            );
            if (scenarios.length) filtered[companyId] = scenarios;
        });
        return filtered;
    }

    sanitizeInput({ companyIds = [], source = "" } = {}) {
        return {
            companyIds: [
                ...new Set((companyIds || []).filter(Boolean).map(String))
            ],
            source: String(source || "").trim()
        };
    }
}
